import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../../mobile.setup';

const parent = Mobile.pages.groups;
const path = 'group-metrics';
const title = 'PAGE.MOBILE.GROUPS.GROUP_METRICS.TITLE';

const res = [];

export const MobileGroupsGroupMetricsTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
